module.exports = __webpack_public_path__ + "img/trash-2.13b82e5e.svg";